import { WriteTableToBody } from './ReportTableWriter';
import { SectionHeading, InlineHeading } from './Headings';

const multipleReportTables = (config, pdf, data) => {
    const tableData = data.Tables.filter(
        (f) => f.Key.toLowerCase() === config.Data.toLowerCase()
    );

    let currentTable = '';
    let rows = [];

    if (tableData.length > 0 && tableData[0].Rows.length > 0) {
        if (pdf.getSavedSectionHeading()) {
            SectionHeading(pdf.getSavedSectionHeading(), pdf);
            pdf.setSavedSectionHeading(undefined);
            // TODO: think about having section margin set on pdf object
            pdf.incrementCurrentLinePositionBy(10);
        }
        for (const row of tableData[0].Rows) {
            const newRow = row.split('|');
            const currentSection = newRow[0];

            if (currentTable !== currentSection) {
                if (currentTable !== '') {
                    // TODO: have a standard section heading config on the pdf object, use standard page margin etc.
                    InlineHeading(
                        [
                            {
                                Bold: true,
                                FontSize: 11,
                                Left: 24,
                                Line: 1,
                                Text: currentTable,
                            },
                        ],
                        pdf
                    );
                    WriteTableToBody(config, pdf, rows);
                    rows = [];
                }
                currentTable = currentSection;
            }

            rows.push(removeFirstElement(row));
        }

        // TODO: another standard section heading config here to move to jspdf
        InlineHeading(
            [
                {
                    Bold: true,
                    FontSize: 11,
                    Left: 24,
                    Line: 1,
                    Text: currentTable,
                },
            ],
            pdf
        );
        WriteTableToBody(config, pdf, rows);
    }
};

const singleReportTable = (config, doc, data) => {
    const tableData = data.Tables.filter(
        (f) => f.Key.toLowerCase() === config.Data.toLowerCase()
    );

    if (tableData.length > 0) {
        WriteTableToBody(config, doc, tableData[0].Rows);
    }
};

const removeFirstElement = row => row.split('|').slice(1).join('|');

export { multipleReportTables as MultipleReportTables, singleReportTable as SingleReportTable };
